import { Vector2Tuple, Vector3 } from 'three';

import { movePolygonInNavMesh, NavMeshQuery } from '@spazious/dollhouse-navmesh';

import getOrientedBox2Corners from './getOrientedBox2Corners.js';

export const moveBoxInNavMesh = (
  center: Vector2Tuple,
  size: Vector2Tuple,
  theta: number,
  movement: Vector3,
  navMeshQuery: NavMeshQuery
): { movement: Vector3; distance: number; success: boolean } => {
  let corners = getOrientedBox2Corners(center, size, theta);
  return movePolygonInNavMesh(corners, movement, navMeshQuery);
};
